(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    function removeLegacyAdditionalDescriptionVideos(root = document) {
      root.querySelectorAll('[data-additional-description]').forEach(container => {
        container.querySelectorAll('iframe, video, .video-open-popup').forEach(element => {
          if (element.closest('.product-tabs-video-grid')) return;

          const paragraph = element.closest('p');
          element.remove();

          if (paragraph && paragraph.textContent.trim() === '' && paragraph.children.length === 0) {
            paragraph.remove();
          }
        });
      });
    }

    removeLegacyAdditionalDescriptionVideos();

    function updateAdatokVariantRows(variantId) {
      if (!variantId) return;

      document.querySelectorAll('[data-adatok-variant-data]').forEach(dataElement => {
        const content = dataElement.closest('.content');
        const rowsRoot = content ? content.querySelector('[data-adatok-variant-rows]') : null;
        if (!rowsRoot) return;

        let variants = [];
        try {
          variants = JSON.parse(dataElement.textContent || '[]');
        } catch (error) {
          return;
        }

        const variant = variants.find(item => String(item.id) === String(variantId));
        if (!variant) return;

        rowsRoot.querySelectorAll('[data-adatok-variant-row]').forEach(row => {
          const valueElement = row.querySelector('[data-adatok-variant-value]');
          const field = row.dataset.adatokVariantField;
          if (!valueElement || !field) return;

          if (field === 'barcode') {
            const barcode = variant.barcode || '';
            valueElement.textContent = barcode;
            row.hidden = barcode === '';
          } else if (field === 'price') {
            valueElement.innerHTML = variant.price || '';
            row.hidden = variant.price === '';
          }
        });
      });
    }

    function variantIdFromEvent(event) {
      const detail = event && event.detail ? event.detail : {};
      const candidates = [
        detail.variant && detail.variant.id,
        detail.selectedVariant && detail.selectedVariant.id,
        detail.productVariant && detail.productVariant.id,
        detail.data && detail.data.variant && detail.data.variant.id,
        detail.variantId,
        detail.id
      ];

      return candidates.find(value => value !== undefined && value !== null && value !== '');
    }

    function selectedVariantId() {
      const variantInputs = Array.from(document.querySelectorAll('form[action*="/cart/add"] [name="id"]'));
      const visibleInput = variantInputs.find(input => {
        const form = input.closest('form');
        return input.value && !input.disabled && form && form.offsetParent !== null;
      });
      const fallbackInput = variantInputs.find(input => input.value);
      if (visibleInput) return visibleInput.value;

      const urlVariantId = new URL(window.location.href).searchParams.get('variant');
      if (urlVariantId) return urlVariantId;

      return (fallbackInput || {}).value;
    }

    function scheduleAdatokVariantUpdate(event) {
      const eventVariantId = variantIdFromEvent(event);
      if (eventVariantId) updateAdatokVariantRows(eventVariantId);

      [0, 75, 200, 500, 1000].forEach(delay => {
        window.setTimeout(() => updateAdatokVariantRows(selectedVariantId()), delay);
      });
    }

    [
      'variant:change',
      'variant:changed',
      'variant-change',
      'product:variant-change',
      'product:variant-changed'
    ].forEach(eventName => document.addEventListener(eventName, scheduleAdatokVariantUpdate));

    document.addEventListener('change', scheduleAdatokVariantUpdate);

    window.addEventListener('popstate', scheduleAdatokVariantUpdate);
    document.addEventListener('shopify:section:load', scheduleAdatokVariantUpdate);
    scheduleAdatokVariantUpdate();

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              removeLegacyAdditionalDescriptionVideos(drawerContent);
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              removeLegacyAdditionalDescriptionVideos(popupContent);
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
